import type { ClientSummary } from '@/features/Clients/Data';
import type { CollaboratorPublic } from '@/features/Collaborators/Data';
import { TIPO_SOLICITACAO_LABELS } from '../../NovaSolicitacaoPage/novaSolicitacaoPage.definitions';
import { STATUS_SOLICITACAO_LABELS, STATUS_SOLICITACAO_BADGE_CLASS } from '../solicitacoesListPage.definitions';
import type { LinhaControle, VisaoControle } from '../solicitacoesLista.utils';
import { dataPrevistaComFluxo } from './solicitacoesKanban.utils';

interface TabelaCompactaControleProps {
  linhas: LinhaControle[];
  visao: VisaoControle;
  clientes: ClientSummary[];
  colaboradores: CollaboratorPublic[];
  onSelect: (linha: LinhaControle) => void;
}

/** Modo "Compacta": uma linha de tabela por linha da lista (Movimentação ou Solicitação). */
export default function TabelaCompactaControle({ linhas, visao, clientes, colaboradores, onSelect }: TabelaCompactaControleProps) {
  return (
    <div className="overflow-x-auto rounded-md border border-gray-200">
      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <thead className="bg-gray-50">
          <tr>
            {['Colaborador', 'Tipo', 'Cliente', 'Status', 'Aberta por', 'Data'].map((coluna) => (
              <th key={coluna} className="px-3 py-2 text-left text-xs font-semibold uppercase text-gray-500">
                {coluna}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {linhas.map((linha) => {
            const { solicitacao, movimentacao } = linha;
            const clienteId = (visao === 'movimentacoes' ? movimentacao?.clienteId : null) ?? solicitacao.clienteId;
            const clienteNome = clientes.find((cliente) => cliente.id === clienteId)?.name ?? null;
            const solicitanteNome =
              colaboradores.find((colaborador) => colaborador.id === solicitacao.solicitanteId)?.name ?? solicitacao.solicitanteEmail;
            return (
              <tr key={linha.chave} className="cursor-pointer hover:bg-gray-50" onClick={() => onSelect(linha)}>
                <td className="whitespace-nowrap px-3 py-2 font-medium text-gray-900">{solicitacao.colaboradorNome}</td>
                <td className="whitespace-nowrap px-3 py-2 text-gray-600">{TIPO_SOLICITACAO_LABELS[solicitacao.tipoSolicitacao]}</td>
                <td className="whitespace-nowrap px-3 py-2 text-gray-600">{clienteNome ?? '—'}</td>
                <td className="whitespace-nowrap px-3 py-2">
                  <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${STATUS_SOLICITACAO_BADGE_CLASS[solicitacao.status]}`}>
                    {STATUS_SOLICITACAO_LABELS[solicitacao.status]}
                  </span>
                </td>
                <td className="whitespace-nowrap px-3 py-2 text-gray-600">{solicitanteNome}</td>
                <td className="whitespace-nowrap px-3 py-2 text-gray-600">{dataPrevistaComFluxo(movimentacao) ?? '—'}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
